import { createSelector } from '@ngrx/store';

import { getLandlordState } from '../reducers';
import { LandlordState } from './landlord.reducers';

export const getUsersData = createSelector(
  getLandlordState,
  (state: LandlordState) => state.usersData
);

export const getCustomersData = createSelector(
  getLandlordState,
  (state: LandlordState) => state.customersData
);

export const getInvoicesData = createSelector(
  getLandlordState,
  (state: LandlordState) => state.invoicesData
);

export const getLandlordActionState = createSelector(
  getLandlordState,
  (state: LandlordState) => state.landlordActionState
);

export const getLandlordPagination = createSelector(
  getLandlordState,
  (state: LandlordState) => state.pagination
);

export const getMailConfigCustomer = createSelector(
  getLandlordState,
  (state: LandlordState) => state.mailConfigCustomer
);

export const getPaymentsData = createSelector(
  getLandlordState,
  (state: LandlordState) => state.paymentsData
);
